module.exports = __webpack_public_path__ + "img/1135682868.7ee5eff2.jpg";